// @ts-nocheck

import palette from '../palette';

export const TMMOdd = {
  borderColor: palette.neutralgrey700,
  oddLabelColor: palette.neutralgrey200,
  oddValueColor: palette.yellowwinamax450,
};

export const TMMCard = {
  backgroundColor: palette.bluegrey850,
  beforeBackgroundColor: palette.bluegrey750,
  beforeColor: palette.white,
  afterBackgroundColor: palette.bluegrey925,
};
